import { useState } from "react";
import { HelpCircle } from "lucide-react";

const InfoTooltip = ({ text }) => {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-block">
      <HelpCircle 
        className="w-3.5 h-3.5 text-slate-500 hover:text-slate-300 cursor-help inline-block ml-1"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      />
      {show && (
        <span className="absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-2 text-xs text-slate-200 bg-slate-800 border border-slate-600 rounded-lg shadow-lg">
          {text}
          <span className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-slate-800"></span>
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
